import { Injectable, OnDestroy } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestoreDocument, AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SelectedSchool } from '../enum/selected-school';
import { News } from '../models/news.model';
import { SelectSchoolService } from './select-school.service';

@Injectable({
  providedIn: 'root'
})
export class UkrainaService implements OnDestroy {

  UkrainaCollection: AngularFirestoreCollection<News>;
  Ukrainas: Observable<News[]>;
  UkrainaDoc?: AngularFirestoreDocument<News>;
  selectedSchool: SelectedSchool;
  dbPath: string;

  constructor(private db: AngularFirestore, private selectSchoolService: SelectSchoolService) {
    this.selectedSchool = this.selectSchoolService.getSchool();
    console.log(this.selectedSchool)
    this.dbPath = 'Ukraina_' + this.selectedSchool;
    this.UkrainaCollection = this.db.collection(`${this.dbPath}/`, ref => ref.orderBy('date','desc'));

    this.Ukrainas = this.UkrainaCollection.snapshotChanges().pipe(map((changes: any[]) => {
      return changes.map(a => {
        const data = a.payload.doc.data() as News;
        data.id = a.payload.doc.id;
        return data;
      });
    }));
   }

  getAllNewses(){
    return this.Ukrainas;
  }
  addNews(News: News){
    console.log(this.dbPath)
    this.UkrainaCollection.add(News);
  }

  deleteNews(News: News){
    this.UkrainaDoc = this.db.doc(`${this.dbPath}/${News.id}`);
    this.UkrainaDoc.delete();
  }

  updateNews(News: News, newNews: News){
    console.log(this.dbPath)
    this.UkrainaDoc = this.db.doc(`${this.dbPath}/${News.id}`);
    this.UkrainaDoc.update(newNews);
  }

  ngOnDestroy(): void {
  }

}
